import { useState, useEffect } from 'react';

/**
 * Hook customizado que retorna `true` se a largura da janela corresponder a uma media query.
 * @param {string} query - A string da media query (ex: '(max-width: 768px)').
 * @returns {boolean} `true` se a query for correspondida, `false` caso contrário.
 */
const useMediaQuery = (query) => {
  // 1. Estado para armazenar se a media query é correspondida ou não.
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    // 2. Obtém o objeto da media query.
    const mediaQueryList = window.matchMedia(query);

    // 3. Define um listener para atualizar o estado quando o resultado da query mudar.
    const listener = (event) => setMatches(event.matches);

    // Adiciona o listener.
    mediaQueryList.addEventListener('change', listener);

    // 4. Função de limpeza: remove o listener quando o componente for desmontado.
    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [query]); // O efeito é re-executado se a string da query mudar.

  return matches;
};

export default useMediaQuery;